import { useEffect, useState } from 'react';
import { Megaphone, X } from 'lucide-react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

export function AnnouncementBanner() {
  const [settings, setSettings] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    axios.get(`${API_URL}/settings`)
      .then(res => setSettings(res.data))
      .catch(() => {});
  }, []);

  if (!settings?.announcement_enabled || !settings?.announcement_text || dismissed) {
    return null;
  }

  return (
    <div
      className="fixed top-16 md:top-20 left-0 right-0 z-40 bg-gradient-to-r from-purple-600 to-cyan-600 py-3 px-4"
      data-testid="announcement-banner"
    >
      <div className="container flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Megaphone className="w-5 h-5" />
          <span className="font-medium">{settings.announcement_text}</span>
        </div>
        <button onClick={() => setDismissed(true)} className="hover:bg-white/10 p-1 rounded" aria-label="Dismiss announcement">
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
